import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Card, Container, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { AiFillCheckCircle } from "react-icons/ai";
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha";
import Layout from "../../components/Layouts/Layouts/Layout";

const PDFViewer = ({ url }) => {
    return (
        <div className="w-100">
            <div className="d-flex justify-content-end mb-3">
                <Button
                    variant="primary"
                    onClick={() => window.open(url, '_blank')}
                    className="d-flex align-items-center gap-2"
                >
                    <i className="fas fa-external-link-alt"></i>
                    Open in Full Screen
                </Button>
            </div>
            <div className="bg-white rounded-lg shadow-sm" style={{ height: "60vh", width: "100%" }}>
                <iframe
                    src={`${url}#toolbar=1&navpanes=1&scrollbar=1`}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen
                    title="PDF Document"
                />
            </div>
        </div>
    );
};

const FeedbackForm = () => {
    const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSfbOT_jGfuhZ2mOR7b2Dm-ytyLuUd3AZ6sQKIIkoi08I1FydQ/formResponse";
    const PDF_URL = "https://www.aecci.org.in/wp-content/uploads/2025/05/PPT-Trade-connect-Representation.pdf";

    const FORM_ENTRY_IDS = {
        chamberName: "entry.177951389",
        officerName: "entry.439249446",
        designation: "entry.1225961753",
        address: "entry.383502037",
        email: "entry.402194411",
        phone: "entry.2064106258",
        presentationFeedback: "entry.2060741313",
        comments: "entry.200416235"
    };


    const chamberOptions = [
        "AGRICULTURAL AND PROCESSED FOOD PRODUCTS EXPORT DEVELOPMENT AUTHORITY(APEDA)",
        "AHMEDABAD EXPORT IMPORT DEVELOPMENT ASSOCIATION",
        "ALL INDIA CHAMBER OF COMMERCE AND INDUSTRIES",
        "ANDHRA CHAMBER OF COMMERCE",
        "ANDHRA PRADESH CHAMBERS OF COMMERCE AND INDUSTRY FEDERATION",
        "APEX CHAMBER OF COMMERCE AND INDUSTRY",
        "APPAREL EXPORT PROMOTION COUNCIL",
        "ASIAN EXPORTERS CHAMBER OF COMMERCE & INDUSTRY",
        "ASMECHEM CHAMBER OF COMMERCE OF INDUSTRY OF INDIA",
        "ASSOCIATED CHAMBERS OF COMMERCE OF INDUSTRY OF U.P.",
        "BAHADURGARH CHAMBER OF COMMERCE & INDUSTRY",
        "BANGALORE CHAMBER OF INDUSTRY AND COMMERCE",
        "BASIC CHEMICALS, COSMETICS & DYES EXPORT PROMOTION COUNCIL",
        "BENGAL NATIONAL CHAMBER OF COMMERCE & INDUSTRY",
        "BHARAT CHAMBER OF COMMERCE",
        "BOMBAY CHAMBER OF COMMERCE AND INDUSTRY",
        "BOMBAY INDUSTRIES ASSOCIATION",
        "CALCUTTA CHAMBER OF COMMERCE",
        "CENTRAL SILK BOARD",
        "CHAMBER OF INDUSTRIAL & COMMERCIAL UNDERTAKINGS",
        "CHAMBER OF MARATHWADA INDUSTRIES AND AGRICULTURE",
        "CHAMBRE DE COMMERCE",
        "COCHIN CHAMBER OF COMMERCE AND INDUSTRY",
        "CONFEDERATION OF INDIA INDUSTRY",
        "COTTON ASSOCIATION OF INDIA",
        "COUNCIL FOR LEATHER EXPORTS",
        "DECCAN CHAMBER OF COMMERCE INDUSTRIES AND AGRICULTURE PUNE",
        "DELHI CHAMBER OF COMMERCE",
        "DIRECTORATE GENERAL OF FOREIGN TRADE",
        "EEPC INDIA(FORMERLY ENGINEERING EXPORT PROMOTION COUNCIL)",
        "ELECTRONICS AND COMPUTER SOFTWARE EXPORT PROMOTION COUNCIL",
        "EXIM CLUB",
        "EXPO OVERSEAS ENTREPRENEURS CHAMBER OF COMMERCE",
        "EXPORT INSPECTION COUNCIL",
        "EASTERN U.P.CHAMBERS OF COMMERCE & INDUSTRY",
        "EXPORT PROMOTION COUNCIL FOR EOUs & SEZs",
        "FALTA SPECIAL ECONOMIC ZONE",
        "FARIDABAD INDUSTRIES ASSOCIATION",
        "FEDERATION OF ANDHRA PRADESH CHAMBERS OF COMMERCE & INDUSTRY",
        "FEDERATION OF GUJARAT INDUSTRIES",
        "FEDERATION OF INDIAN EXPORT ORGANISATIONS",
        "FEDERATION OF INDIAN MICRO AND SMALL & MEDIUM ENTERPRISES(FISME)",
        "FEDERATION OF INDUSTRIES AND ASSOCIATIONS(GUJARAT)",
        "FEDERATION OF INDUSTRY & COMMERCE OF NORTH EASTERN REGION(FINER)",
        "FEDERATION OF KARNATAKA CHAMBERS OF COMMERCE AND INDUSTRY",
        "FEDERATION OF KUTCH INDUSTRIES ASSOCIATIONS",
        "FEDERATION OF MADHYA PRADESH CHAMBERS OF COMMERCE AND INDUSTRY",
        "FEDERATION OF PUNJAB SMALL INDUSTRIES ASSOCIATIONS",
        "FOREIGN TRADE DEVELOPMENT ASSOCIATION OF INDIA",
        "GEM & JEWELLERY EXPORT PROMOTION COUNCIL(GJEPC)",
        "GOA CHAMBER OF COMMERCE AND INDUSTRY",
        "GUJARAT CHAMBER OF COMMERCE AND INDUSTRY",
        "GURGAON CHAMBER OF COMMERCE AND INDUSTRY",
        "HINDUSTAN CHAMBER OF COMMERCE",
        "HINDUSTAN CHAMBER OF COMMERCE - MUMBAI",
        "IMC CHAMBER OF COMMERCE AND INDUSTRY",
        "INDIAN CHAMBER OF COMMERCE",
        "INDIAN CHAMBER OF COMMERCE & INDUSTRY COCHIN",
        "INDIAN CHAMBER OF COMMERCE AND INDUSTRY TUTICORIN",
        "INDIAN CHEMICAL COUNCIL",
        "INDIAN ELECTRICAL & ELECTRONICS MANUFACTURERS ASSOCIATION(IEEMA)",
        "INDIAN IMPORTERS CHAMBERS OF COMMERCE AND INDUSTRY",
        "INDIAN INDUSTRIES ASSOCIATION",
        "INDIAN OILSEEDS & PRODUCE EXPORT PROMOTION COUNCIL",
        "INDO - ARAB CHAMBER OF COMMERCE & INDUSTRIES",
        "INDO - LATIN AMERICAN CHAMBER OF COMMERCE",
        "JAMNAGAR CHAMBER OF COMMERCE AND INDUSTRY",
        "KANARA CHAMBER OF COMMERCE AND INDUSTRY",
        "KANDLA SPECIAL ECONOMIC ZONE",
        "KARNATAKA SMALL SCALE INDUSTRIES ASSOCIATION(KASSIA)",
        "KERALA CHAMBER OF COMMERCE AND INDUSTRY",
        "LAGHU UDYOG BHARATI",
        "M.P.CHAMBER OF COMMERCE & INDUSTRY",
        "M.VISVESVARAYA INDUSTRIAL RESEARCH AND DEVELOPMENT CENTRE",
        "MAHARASHTRA CHAMBER OF COMMERCE INDUSTRY & AGRICULTURE",
        "MAHRATTA CHAMBER OF COMMERCE, INDUSTRIES AND AGRICULTURE",
        "MALDA MERCHANTS CHAMBER OF COMMERCE",
        "MARINE PRODUCTS EXPORT DEVELOPMENT AUTHORITY",
        "MARWAR CHAMBER OF COMMERCE AND INDUSTRY",
        "MEGHALAYA EXPORTER'S CHAMBER OF COMMERCE",
        "MERCHANTS CHAMBER OF COMMERCE & INDUSTRY",
        "MERCHANTS CHAMBER OF UTTAR PRADESH",
        "MEWAR CHAMBER OF COMMERCE & INDUSTRY",
        "MIDC INDUSTRIES ASSOCIATION HINGNA",
        "MILLENNIAL INDIA INTERNATIONAL CHAMBER OF COMMERCE INDUSTRY & AGRICULTURE(MIICCIA)",
        "NAG VIDARBHA CHAMBER OF COMMERCE",
        "NATIONAL CHAMBER OF INDUSTRIES & COMMERCE, U.P.",
        "NOIDA SPECIAL ECONOMIC ZONE",
        "NORTH EAST FEDERATION ON INTERNATIONAL TRADE",
        "NORTHERN INDIA CHAMBER OF COMMERCE AND INDUSTRY",
        "ORIENTAL CHAMBER OF COMMERCE AND INDUSTRY",
        "PHARMACEUTICALS EXPORT PROMOTION COUNCIL OF INDIA",
        "PHD CHAMBER OF COMMERCE AND INDUSTRY",
        "PORBANDAR CHAMBER OF COMMERCE AND INDUSTRY",
        "POWERLOOM DEVELOPMENT & EXPORT PROMOTION COUNCIL",
        "PURBACHAL EXIM CHAMBER OF COMMERCE, TRIPUR",
        "RAIGAD CHAMBER OF COMMERCE AND INDUSTRY",
        "RAJASTHAN CHAMBER OF COMMERCE AND INDUSTRY",
        "RAJKOT CHAMBER OF COMMERCE AND INDUSTRY",
        "RAJKOT ENGINEERING ASSOCIATION",
        "SAURASHTRA CHAMBER OF COMMERCE AND INDUSTRY",
        "SEEPZ SPECIAL ECONOMIC ZONE",
        "SHRI SORATH CHAMBER OF COMMERCE AND INDUSTRY",
        "SOUTH INDIAN CHAMBER OF COMMERCE AND INDUSTRY",
        "TAMILNADU CHAMBER OF COMMERCE AND COMMERCE",
        "TAMILNADU CHAMBER OF COMMERCE AND INDUSTRY",
        "TEST COO AGENCY",
        "TEXTILES COMMITTEE",
        "THANE SMALL SCALE INDUSTRIES ASSOCIATION",
        "THE ALL INDIA ASSOCIATION OF INDUSTRIES(AIAI)",
        "THE ALL INDIA EXPORTERS CHAMBER",
        "THE ALL INDIA PLASTICS MANUFACTURERS ASSOCIATION",
        "THE ALL INDIA SKIN AND HIDE TANNERS AND MERCHANTS ASSOCIATION(AISHTMA)",
        "THE ASSOCIATED CHAMBERS OF COMMERCE AND INDUSTRY OF INDIA",
        "THE BELGAUM CHAMBER OF COMMERCE & INDUSTRIES",
        "THE BENGAL CHAMBER OF COMMERCE AND INDUSTRY",
        "THE CASHEW EPC OF INDIA",
        "THE CLOTHING MANUFACTURERS ASSOCIATION OF INDIA",
        "THE COCANADA CHAMBER OF COMMERCE",
        "THE COTTON TEXTILES EXPORT PROMOTION COUNCIL",
        "THE EASTERN U.P.CHAMBER OF COMMERCE AND INDUSTRY",
        "THE FEDERATION OF TELANGANA CHAMBERS OF COMMERCE AND INDUSTRY",
        "THE GANDHIDHAM CHAMBER OF COMMERCE AND INDUSTRY",
        "THE INDIAN CHAMBER OF COMMERCE AND INDUSTRY COIMBATORE"
    ];

    const initialFormData = {
        chamberName: "",
        officerName: "",
        designation: "",
        address: "",
        email: "",
        phone: "",
        presentationEffective: false,
        presentationNeedsImprovement: false,
        comments: "",
    };

    const [formData, setFormData] = useState(initialFormData);
    const [captchaValue, setCaptchaValue] = useState("");
    const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const captchaLength = 6;

    useEffect(() => {
        loadCaptchaEnginge(captchaLength);
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleCaptchaChange = (e) => {
        const value = e.target.value;
        setCaptchaValue(value);
        setIsCaptchaCorrect(validateCaptcha(value, false));
    };

    const resetForm = () => {
        setFormData(initialFormData);
        setCaptchaValue("");
        setIsCaptchaCorrect(false);
        setValidated(false);
        loadCaptchaEnginge(captchaLength);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (form.checkValidity() === false || !isCaptchaCorrect) {
            e.stopPropagation();
            setValidated(true);
            toast.error("Please fill all required fields and validate CAPTCHA.");
            return;
        }

        setIsSubmitting(true);
        try {
            const formDataToSend = new FormData();
            formDataToSend.append(FORM_ENTRY_IDS.chamberName, formData.chamberName);
            formDataToSend.append(FORM_ENTRY_IDS.officerName, formData.officerName);
            formDataToSend.append(FORM_ENTRY_IDS.designation, formData.designation);
            formDataToSend.append(FORM_ENTRY_IDS.address, formData.address);
            formDataToSend.append(FORM_ENTRY_IDS.email, formData.email);
            formDataToSend.append(FORM_ENTRY_IDS.phone, formData.phone);

            const feedback = [];
            if (formData.presentationEffective) feedback.push("Effective");
            if (formData.presentationNeedsImprovement) feedback.push("Needs Improvement");
            formDataToSend.append(FORM_ENTRY_IDS.presentationFeedback, feedback.join(", "));

            formDataToSend.append(FORM_ENTRY_IDS.comments, formData.comments);

            const response = await fetch(GOOGLE_FORM_URL, {
                method: "POST",
                mode: "no-cors",
                body: formDataToSend
            });

            console.log(response)
            resetForm();
            setShowSuccessModal(true);
        } catch (error) {
            toast.error("An error occurred while submitting the form.");
            console.error("Form submission error:", error);
        } finally {
            setIsSubmitting(false);
        }
    }


    return (
        <Layout>
            <Container fluid className="py-5 bg-light min-vh-100">
                <Container className="px-lg-5">
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-4 p-md-5">
                            <div className="mb-5">
                                <h5 className="text-lg font-semibold mb-4">
                                    Chambers — Inputs invited on AECCI's Presentation Shared with the Ministry of Commerce
                                    & Industry, Government of India and O/o. the Director General of Foreign Trade, Delhi.
                                </h5>

                                <Card className="bg-light border-0 mb-5">
                                    <Card.Body className="p-4 fw-semibold">
                                        <p className="text-gray-700 mb-3">
                                            Dear Chamber Representative,
                                        </p>
                                        <p className="text-gray-600">
                                            We are pleased to invite your valuable inputs, comments or suggestions regarding the presentation we have already shared with the ministry. As we await their response, we would be happy to include any additional points you wish to share in our further communication with them.
                                        </p>
                                    </Card.Body>
                                </Card>

                                <div className="mb-5">
                                    <h4 className="text-2xl font-semibold mb-4 text-primary">Presentation</h4>
                                    <Card className="border-0 bg-light">
                                        <Card.Body className="p-4">
                                            <PDFViewer url={PDF_URL} />
                                        </Card.Body>
                                    </Card>
                                </div>

                                <h4 className="text-2xl font-semibold mb-4 text-primary">Please fill in the details below:</h4>
                            </div>

                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Row className="g-4">
                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Name of Chamber <span className="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                name="chamberName"
                                                value={formData.chamberName}
                                                onChange={handleInputChange}
                                                required
                                                className="form-control-lg border-2"
                                            >
                                                <option value="">Select Chamber...</option>
                                                {chamberOptions.map((chamber, index) => (
                                                    <option key={index} value={chamber}>
                                                        {chamber}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a chamber.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Officer Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="officerName"
                                                value={formData.officerName}
                                                onChange={handleInputChange}
                                                required
                                                maxLength={50}
                                                className="form-control-lg border-2"
                                                placeholder="Enter officer name"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the officer's name.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Designation <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="designation"
                                                value={formData.designation}
                                                onChange={handleInputChange}
                                                required
                                                maxLength={50}
                                                className="form-control-lg border-2"
                                                placeholder="Enter designation"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the designation.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Address <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleInputChange}
                                                required
                                                maxLength={200}
                                                rows={3}
                                                className="border-2"
                                                placeholder="Enter your address"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter the address.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Contact Email <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                                maxLength={50}
                                                className="form-control-lg border-2"
                                                placeholder="Enter email address"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid email.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Phone <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                                required
                                                maxLength={15}
                                                className="form-control-lg border-2"
                                                placeholder="Enter phone number"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid phone number.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12}>
                                        <Card className="border-0 bg-light">
                                            <Card.Body>
                                                <h5 className="mb-4">How did you find the points raised in our presentation?</h5>
                                                <Form.Group className="d-flex flex-column gap-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        name="presentationEffective"
                                                        label="Effective"
                                                        checked={formData.presentationEffective}
                                                        onChange={handleInputChange}
                                                        className="d-flex align-items-center custom-checkbox"
                                                        style={{ gap: '10px' }}
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        name="presentationNeedsImprovement"
                                                        label="Needs Improvement"
                                                        checked={formData.presentationNeedsImprovement}
                                                        onChange={handleInputChange}
                                                        className="d-flex align-items-center custom-checkbox"
                                                        style={{ gap: '10px' }}
                                                    />
                                                </Form.Group>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label className="fw-bold fs-6">Your Comments / Suggestions / Additional Points:</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="comments"
                                                value={formData.comments}
                                                onChange={handleInputChange}
                                                maxLength={500}
                                                rows={4}
                                                className="border-2"
                                                placeholder="Enter your Comments and Suggestions here..."
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12}>
                                        <Card className="border-0 bg-light">
                                            <Card.Body className="p-4">
                                                <Row className="g-4 align-items-center">
                                                    <Col xs={12} md={6}>
                                                        <div className="d-flex flex-column align-items-center">
                                                            <LoadCanvasTemplate />
                                                            {isCaptchaCorrect && (
                                                                <AiFillCheckCircle className="text-success mt-2" size={24} />
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={6}>
                                                        <Form.Group>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter CAPTCHA"
                                                                value={captchaValue}
                                                                onChange={handleCaptchaChange}
                                                                maxLength={captchaLength}
                                                                required
                                                                className="form-control-lg border-2"
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please enter a valid CAPTCHA.
                                                            </Form.Control.Feedback>
                                                            {isCaptchaCorrect ? (
                                                                <p className="text-success mt-2 mb-0">CAPTCHA is valid</p>
                                                            ) : (
                                                                <p className="text-danger mt-2 mb-0">CAPTCHA is invalid</p>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>

                                <Col xs={12} className="d-flex justify-content-between mt-4 flex-column flex-md-row gap-3">
                                    <Button
                                        variant="outline-danger"
                                        onClick={resetForm}
                                        className="px-4 py-2 rounded-pill w-100 w-md-auto"
                                        disabled={isSubmitting}
                                        size="lg"
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="px-4 py-2 rounded-pill w-100 w-md-auto"
                                        disabled={isSubmitting}
                                        size="lg"
                                    >
                                        {isSubmitting ? "Submitting..." : "Submit"}
                                    </Button>
                                </Col>
                            </Form>

                            <Modal
                                show={showSuccessModal}
                                onHide={() => setShowSuccessModal(false)}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Submission Successful</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Thank you for your feedback! Your response has been successfully submitted.
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="primary"
                                        onClick={() => setShowSuccessModal(false)}
                                    >
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </Card.Body>
                    </Card>
                </Container>
            </Container>

            <style>
                {`
                    .custom-checkbox .form-check-label {
                        font-size: 1.1rem !important;
                        text-wrap: nowrap !important;
                    }
                `}
            </style>
        </Layout>
    );
};

export default FeedbackForm;